import { Stack } from "@mui/material";
import type { FC } from "react";
import { DashboardImageCardSection } from "web_myplann/Dashboard/Components/DashboardImageCardSection";
import { DashboardMainSection } from "web_myplann/Dashboard/Components/DashboardMainSection";
import { DashboardShell } from "web_myplann/Dashboard/Components/DashboardShell";
import { FinancialBalance } from "web_myplann/Dashboard/Components/FinancialBalance";

export const DashboardPage: FC = () => (
	<DashboardShell>
		<Stack pb={2}>
			<DashboardMainSection />
			<Stack pt={2.4} px={1.6}>
				<FinancialBalance />
			</Stack>
			<DashboardImageCardSection />
		</Stack>
	</DashboardShell>
);
